define([
    'text!../templates/modal-window-template.html'
], (ModalWindowTemplate) => {
    return ['$timeout', ($timeout)=> {
        return {
            restrict: 'EA',
            scope: {
                index: '@'
            },
            replace: true,
            transclude: true,
            template: ModalWindowTemplate,
            link(scope, element, attrs) {
                scope.windowClass = attrs.windowClass || '';

                // focus a freshly-opened modal
                element[0].focus();

                $timeout(()=> {
                    // trigger CSS transitions
                    scope.animate = true;
                });
            }
        };
    }];
});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/widgets/modal/directives/ModalWindow.js